import { buildSparkline } from "./buildSparkline";
import { SparkAreaPath, SparkLinePath, SparkSvg } from "./styles";
import { SparklineProps } from "./types";

export const Sparkline: React.FC<SparklineProps> = ({ data, tone }) => {
  if (data.length === 0) {
    return null;
  }

  const { line, area, viewBox } = buildSparkline(data);

  return (
    <SparkSvg viewBox={viewBox} preserveAspectRatio="none" aria-hidden="true">
      <SparkAreaPath d={area} $tone={tone} />
      <SparkLinePath d={line} $tone={tone} />
    </SparkSvg>
  );
};
